module.exports = __webpack_public_path__ + "img/default-profile-picture.7e9e18be.jpg";